import React from 'react'

const AccordionTab = ({ title, priority, children }) => {
    const [isOpen, setOpen] = React.useState(false);
    return (
        <div className="accordion__wrapper" data-priority={priority}>
            <div
                className={`accordion__title ${isOpen ? "open" : ""}`}
                onClick={() => setOpen(!isOpen)}
            >
                <div className="accordion__icon"><i className="fas fa-angle-down"></i></div>
                <h4 className="headline headline--sub" dangerouslySetInnerHTML={{__html: title}}></h4>
            </div>
            <div className={`accordion__item ${!isOpen ? "collapsed" : ""}`}>
                <div className="accordion__content">{children}</div>
            </div>
        </div>
    );
};

export default AccordionTab
